import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/auth.service';
import { SocialService } from 'src/app/core/services/social.service';
import { faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-instuctor-socials',
  templateUrl: './instuctor-socials.component.html',
  styleUrls: ['./instuctor-socials.component.sass']
})
export class InstuctorSocialsComponent implements OnInit {
  currentIndex: any = -1;
  showFlag: any = false;
  instaImageObject: Array<object> = [];
  fbImageObject: Array<object> = [];
  callMade = false;
  callFinished = false;
  instructorId: string;
  faInstagram = faInstagram;
  faFacebook = faFacebookF;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private socialService: SocialService, private authService: AuthService, private spinner: NgxSpinnerService) {

  }

  ngOnInit(): void {
    //this.spinner.show();
    this.instructorId = this.data.instructorId
    this.authService.currentUser.pipe(take(1)).subscribe((user) => {
      if (user !== null && this.instructorId != null && !this.callMade) {
        this.callMade = true;
        const callable = this.socialService.getIntstructorFacebookPosts(user.userId, this.instructorId);
        callable.subscribe((data) => {
          this.callFinished = true;
          console.log(data);

          for (var i = 0; i < data['posts']?.data?.length; i++) {
            const obj = data['posts']?.data[i];
            this.fbImageObject.push({
              image: obj.full_picture,
              title: obj.message || obj.description
            });
          }
          console.log(this.fbImageObject)
        });
        const instaCallable = this.socialService.getInstagramContent(this.instructorId);
        instaCallable.subscribe(data => {
          console.log('INSTA ', data);
          this.spinner.hide();
          for (var i = 0; i < data['posts']?.data.length; i++) {
            const obj = data['posts']?.data[i];
            if (obj.media_url !== undefined) {
              this.instaImageObject.push({
                image: obj.media_url,
                title: obj.message || obj.description
              });
            }
          }
        })
      }
    });
  }

  showLightbox(index) {
    this.currentIndex = index;
    this.showFlag = true;
  }

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }
}
